module.exports = __webpack_public_path__ + "static/media/danger.eb3739bc.svg";